export enum AuthGuardTypeFlag {
    GUEST_ALLOWED = 1,
    UNREGISTERED_ONLY = 2,
    ARTEMIS_ONLY = 3,
    PBRIS_ONLY = 4,
    ADMIN_ONLY = 5,
}